import {
    useDocsI18n
} from "../i18n";
import {
    useDocsRouter
} from "../router";
import {
    Command
} from "ncore-ui-kit";
import {
    type DocsNavItem,
    BLOCKS_NAV,
    CREATE_NAV,
    DOCS_NAV
} from "../nav";

const SEARCH_SECTIONS = [
    ...DOCS_NAV,
    BLOCKS_NAV,
    CREATE_NAV
];

type SearchDialogProps = {
    onOpenChange: (isOpen: boolean) => void;
    isOpen: boolean;
};

const SearchDialog = ({
    onOpenChange,
    isOpen
}: SearchDialogProps) => {
    const {
        t
    } = useDocsI18n();

    const {
        navigate
    } = useDocsRouter();

    const getTitle = (item: DocsNavItem) => item.title ?? t(item.titleKey ?? "");

    const getKeywords = (item: DocsNavItem, sectionTitleKey: string) => {
        const lead = t(item.leadKey);

        return [
            t(sectionTitleKey),
            item.path,
            ...(lead === item.leadKey ? [] : [
                lead
            ])
        ];
    };

    const handleSelect = (item: DocsNavItem) => {
        onOpenChange(false);

        navigate(item.path);
    };

    return <Command.Dialog
        onOpenChange={onOpenChange}
        title={t("search.label")}
        isOpen={isOpen}
    >
        <Command
            variant="dialog"
        >
            <Command.Input
                placeholder={t("search.placeholder")}
            />
            <Command.List>
                <Command.Empty
                    title={t("search.empty")}
                />
                {
                    SEARCH_SECTIONS.flatMap((section) => section.groups.map((group) => <Command.Group
                        title={t(group.titleKey)}
                        key={group.id}
                    >
                        {
                            group.items.map((item) => <Command.Item
                                keywords={getKeywords(item, section.titleKey)}
                                onPress={() => handleSelect(item)}
                                title={getTitle(item)}
                                key={item.path}
                            />)
                        }
                    </Command.Group>))
                }
            </Command.List>
            <Command.Footer/>
        </Command>
    </Command.Dialog>;
};
export default SearchDialog;
